enum LoginScope {
  EMAIL = 'email',
  OFFLINE = 'offline',
  PLAYFAB = 'playfab',
}

enum ResponseType {
  CODE = 'code',
  TOKEN = 'token',
}

enum SocialProvider {
  AMAZON = 'amazon',
  APPLE = 'apple',
  BAIDU = 'baidu',
  BATTLENET = 'battlenet',
  DISCORD = 'discord',
  FACEBOOK = 'facebook',
  GITHUB = 'github',
  GOOGLE = 'google',
  INSTAGRAM = 'instagram',
  KAKAO = 'kakao',
  LINKEDIN = 'linkedin',
  MAILRU = 'mailru',
  MICROSOFT = 'microsoft',
  MSN = 'msn',
  NAVER = 'naver',
  OK = 'ok',
  PARADOX = 'paradox',
  PAYPAL = 'paypal',
  PSN = 'psn',
  QQ = 'qq',
  REDDIT = 'reddit',
  STEAM = 'steam',
  TWITCH = 'twitch',
  TWITTER = 'twitter',
  VIMEO = 'vimeo',
  VK = 'vk',
  WECHAT = 'wechat',
  WEIBO = 'weibo',
  YAHOO = 'yahoo',
  YANDEX = 'yandex',
  YOUTUBE = 'youtube',
  XBOX = 'xbox',
  PLAYSTATION = 'playstation',
}

export { LoginScope, ResponseType, SocialProvider };
